import MainDispatcher from '../support/MainDispatcher';
import LoggedoutActions from '../actions/LoggedoutActions';
import store from './Store';

const _passwordKeys = {},
  _emailVerificationKeys = {};

let _resetSuccess = false,
  _resendVerificationEmailSuccess = false,
  _errors = {};

const LoggedoutStore = store({
  resetSuccess: function() {
    return _resetSuccess;
  },
  resendVerificationSuccess: function() {
    return _resendVerificationEmailSuccess;
  },
  isPasswordKeyValid: function(key, type) {
    if (!_passwordKeys[key]) {
      setTimeout(function() {
        LoggedoutActions.checkPasswordKey(key, type);
      }, 0);
    }
    return _passwordKeys[key];
  },
  verifyUser: function(token) {
    if (!_emailVerificationKeys[token]) {
      setTimeout(function() {
        LoggedoutActions.verifyUserEmail(token);
      }, 0);
    }
    return _emailVerificationKeys[token];
  },
  getErrors: function() {
    return _errors;
  }
});

LoggedoutStore.dispatchToken = MainDispatcher.register(function(action) {
  switch (action.action) {
    case 'PASSWORD_KEY_LOADING':
      _passwordKeys[action.key] = 'PASSWORD_KEY_LOADING';
      LoggedoutStore.emitChange();
      break;
    case 'PASSWORD_KEY_VALID':
      _passwordKeys[action.key] = 'PASSWORD_KEY_VALID';
      LoggedoutStore.emitChange();
      break;
    case 'PASSWORD_KEY_INVALID':
      _passwordKeys[action.key] = 'PASSWORD_KEY_INVALID';
      LoggedoutStore.emitChange();
      break;
    case 'EMAIL_VERIFICATION_IN_PROGRESS':
      _emailVerificationKeys[action.token] = 'EMAIL_VERIFICATION_IN_PROGRESS';
      LoggedoutStore.emitChange();
      break;
    case 'EMAIL_VERIFICATION_SUCCESSFUL':
      _emailVerificationKeys[action.token] = 'EMAIL_VERIFICATION_SUCCESSFUL';
      LoggedoutStore.emitChange();
      break;
    case 'EMAIL_ALREADY_VERIFIED':
      _emailVerificationKeys[action.token] = 'EMAIL_ALREADY_VERIFIED';
      LoggedoutStore.emitChange();
      break;
    case 'EMAIL_VERIFICATION_FAILED':
      _emailVerificationKeys[action.token] = 'EMAIL_VERIFICATION_FAILED';
      LoggedoutStore.emitChange();
      break;
    case 'LOGGEDOUT_ERROR':
      _errors = {};
      _errors[action.error.field] = action.error.message;
      LoggedoutStore.emitChange();
      break;

    case 'RATE_LIMIT_ERROR':
      _errors = action.error;
      _errors.message = action.error.statusText;
      LoggedoutStore.emitChange();
      break;

    case 'SERVER_ERROR':
      _errors = action.error;
      _errors.message = action.error.statusText;
      LoggedoutStore.emitChange();
      break;

    case 'RESET_EMAIL_SENT':
      _errors = {};
      _resetSuccess = true;
      LoggedoutStore.emitChange();
      break;

    case 'VERIFICATION_EMAIL_SENT':
      _errors = {};
      _resendVerificationEmailSuccess = true;
      LoggedoutStore.emitChange();
      break;

    case 'SET_PASSWORD_SUCCESS':
    /* falls through */
    case 'CLEAR_ERRORS':
      _errors = {};
      _resetSuccess = false;
      LoggedoutStore.emitChange();
      break;
  }
});

export default LoggedoutStore;
